import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TooltipService } from '@_services/tooltip.service';

@Component({
  selector: 'app-wills-details-tab',
  templateUrl: './wills-details-tab.component.html',
  styleUrls: ['./wills-details-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WillsDetailsTabComponent implements OnInit {
  @Input() WillEstateForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() islegalEstate: any = false;
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  constructor(
    public datepipe: DatePipe,
    public tooltipService: TooltipService,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {}

  /**
   * This funcgion is used to
   */
  CommanDatePickerEvent(type: string, event: MatDatepickerInputEvent<Date>, formField: any = '') {
    this.WillEstateForm.controls[formField].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }

  /**
   * This function is used to get the text data value
   */
  myFunction(event: any) {
    // var copyText: any = document.getElementById("myInput");
    // copyText.select();
    // copyText.setSelectionRange(0,9999);
    // navigator.clipboard.writeText(copyText.value)
    // var copyText: any = document.getElementById("myInput");
    // event.select();
    // event.setSelectionRange(0,9999);
    navigator.clipboard.writeText(event);
  }
}
